import React from 'react'

// Components
import Header from 'components/Header'
import Footer from 'components/Footer'
import CookieBanner from 'components/CookieBanner'

// Styling
import './layout.css'

interface Props {
  children: React.ReactNode[] | React.ReactNode
  theme: 'Light' | 'Dark'
}

const Layout: React.FC<Props> = ({ theme, children }) => {
  return (
    <>
      <Header pageTheme={theme} />
      <main role="main">{children}</main>
      <Footer
        title={
          'Stay tuned - snart får vi en ny webb. Vi lovar, det är värt väntan.'
        }
      >
        <p>
          Camelonta kombinerar teknik, kreativitet och strategi för att skapa
          lösningar som inte bara fungerar – utan som också berör. Vår styrka
          ligger i att forma digitala upplevelser efter varje kunds unika behov.
          Allt från webbutveckling och plattformar till design och långsiktiga
          partnerskap.
        </p>
      </Footer>
      {/* <CookieBanner /> */}
    </>
  )
}

export default Layout
